<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="
      'page.training_qualifications.finalize.modal.extend_existing_qualifications.header'
        | translate
    "
    [nzActive]="active"
    [nzCollapsible]="disabled ? 'disabled' : undefined"
  >
    <!-- Existing Qualifications -->
    <div class="finalize-existing-qualifications">
      <span class="finalize-existing-qualifications__header">
        {{ 'general.qualifications' | translate }}
      </span>
      <div>
        @for (
          existingQualification of existingQualificationFromTrainings;
          track existingQualification.qualificationId
        ) {
          <nz-tag>{{
            existingQualification.qualificationId | qualificationV2Name | async
          }}</nz-tag>
        }
      </div>
    </div>

    <!-- Valid Until + Infinite -->
    <div nz-row [nzGutter]="16" nzAlign="bottom">
      <div nz-col nzSpan="21">
        <nz-form-item>
          <nz-form-label
            class="quali-form-label"
            nzNoColon
            [nzRequired]="
              validUntilFormControl.hasValidator(Validators.required)
            "
          >
            {{ 'general.valid_until' | translate }}
          </nz-form-label>
          <nz-form-control
            [nzValidateStatus]="validUntilFormControl"
            nzHasFeedback
          >
            @if (!infiniteValidFormControl?.value) {
              <nz-date-picker
                [formControl]="validUntilFormControl"
                [nzDisabledDate]="disabledValidUntilDates"
                [nzFormat]="'P'"
                [nzPlaceHolder]="'general.select_date' | translate"
              ></nz-date-picker>
            } @else {
              <input
                nz-input
                [value]="'∞'"
                disabled
                style="cursor: not-allowed"
              />
            }
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="3">
        <nz-form-item>
          <nz-form-label class="quali-form-label" nzNoColon>
            {{ 'general.infinite' | translate }}
          </nz-form-label>
          <nz-form-control>
            <nz-switch [formControl]="infiniteValidFormControl"></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- Confirmed By Employee -->
    <nz-form-item>
      <nz-form-label class="quali-form-label" nzNoColon>
        {{ 'qualifications.create.confirmed_by_employee' | translate }}
      </nz-form-label>
      <nz-form-control>
        <nz-select
          [formControl]="confirmedByEmployeeFormControl"
          [nzPlaceHolder]="'general.select_date' | translate"
        >
          <nz-option
            [nzValue]="false"
            [nzLabel]="'page.qualifications.not_confirmed' | translate"
          ></nz-option>
          <nz-option
            [nzValue]="true"
            [nzLabel]="'page.qualifications.confirmed' | translate"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </nz-collapse-panel>
</nz-collapse>
